<template>
  <van-popup
    class="benefit-popup-wrap"
    :value="value"
    @click-overlay="closePopup"
    @click-close-icon="closePopup"
  >
    <div class="benefit-popup-content-wrap">
      <div class="benefit-popup-name">{{ benefitData.desc }}</div>
      <div class="benefit-value">权益价值{{ benefitData.lowest_price }}元</div>
      <div class="benefit-action">
        <van-field
          v-model="inputValue"
          placeholder="请输入手机号"
          class="action-input"
          :maxlength="11"
        ></van-field>
        <div class="action-btn" @click="activeMember">立即开通</div>
        <div class="action-desc">
          <p>次月起按9.9/月自动续费，可随时取消</p>
        </div>
        <div class="action-agreement">
          <van-radio v-model="isAgree" class="radio" :icon-size="14" name="1" />
          我已阅读并同意<span class="link" @click="showArgument"
            >《服务协议》</span
          >
        </div>
      </div>
    </div>
    <div class="benefit-popup-close-btn">
      <svg-icon icon-class="close-btn" @click="closePopup" />
    </div>
  </van-popup>
</template>

<script>
import { defineComponent, ref } from "@vue/composition-api";
import Vue from "vue";

import { signByPhone, queryMemberCardInfo } from "@/apis/product";
import { useRoute, useStore } from "@/components/use/base";

const vm = Vue.prototype;

export default defineComponent({
  props: ["value", "benefitData"],
  setup(props, { emit }) {
    const route = useRoute();
    const store = useStore();
    const { channel_source, auth_code } = route.query;

    const inputValue = ref(store.state.userInfo.login_phone_number || "");
    const isAgree = ref(false);

    const closePopup = () => {
      emit("update:value", false);
    };

    const activeMember = async () => {
      if (!/^1[3-9]\d{9}$/.test(inputValue.value)) {
        vm.$toast("请输入正确的手机号");
        return;
      }
      if (!inputValue.value) {
        vm.$toast("请输入手机号");
        return;
      }
      if (!isAgree.value) {
        vm.$toast("请先阅读并同意服务协议");
        return;
      }
      const { data } = await queryMemberCardInfo({
        phone_number: inputValue.value,
        access_code: auth_code,
      });
      const cardList = data?.card_list || [];
      const openId = data?.open_id || "";
      const arr = cardList?.filter((item) => !item.is_active) || [];
      if (arr.length === 0) {
        vm.$toast("当日会员卡已售罄，请次日重试");
        return;
      }
      const { data: signData } = await signByPhone({
        phone_number: inputValue.value,
        namespace: arr[0].namespace_name,
        item_code: arr[0].package_name,
        source: channel_source || "default",
        open_id: openId,
        access_code: auth_code,
      });
      window.location.href = signData.sign_url;
    };

    const showArgument = () => {
      location.href = "https://cdn.xiangshuheika.com/h5/agreement/xssqk.html";
    };

    return {
      inputValue,
      isAgree,
      closePopup,
      activeMember,
      showArgument,
    };
  },
});
</script>

<style lang="less" scoped>
.benefit-popup-wrap {
  width: 295px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0);

  .benefit-popup-content-wrap {
    position: relative;
    background: url("https://common-h5-dev.xiangshuheika.com/static/upload/20250827106443833b6bc.png")
      no-repeat;
    background-size: 100%;
    height: 357px;

    .benefit-popup-name {
      position: absolute;
      top: 110px;
      left: 28px;
      font-weight: 500;
      font-size: 14px;
      font-weight: 600;
      color: rgb(171, 101, 63);
    }

    .benefit-value {
      position: absolute;
      top: 150px;
      left: 28px;
      width: 108px;
      height: 25px;
      background: linear-gradient(180deg, #b77556 0%, #a5471c 100%);
      border-radius: 8px;

      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      line-height: 25px;
      text-align: center;
    }

    .benefit-action {
      position: absolute;
      top: 213px;
      left: 12px;
      right: 12px;

      .action-input {
        border-radius: 8px;
        height: 40px;

        /deep/ .van-field__control {
          line-height: 20px;
          text-align: center;
        }
      }

      .action-btn {
        margin-top: 12px;
        width: 271px;
        height: 40px;
        background: linear-gradient(115deg, #dfbd94 0%, #ffe8c8 100%);
        border-radius: 24px;

        font-weight: 500;
        font-size: 18px;
        color: #642407;
        line-height: 40px;
        text-align: center;
      }

      .action-desc {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 8px;
        font-weight: 400;
        font-size: 10px;
        line-height: 14px;
        color: #999999;
      }

      .action-agreement {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 4px;
        font-weight: 400;
        font-size: 10px;
        line-height: 14px;
        color: #999999;

        .radio {
          margin-right: 7px;
        }

        .link {
          color: #0170fe;
        }
      }
    }
  }

  .benefit-popup-close-btn {
    margin-top: 36px;
    background: rgba(0, 0, 0, 0);
    font-size: 24px;
    text-align: center;
  }
}
</style>
